import * as React from 'react';
import { FC, PropsWithChildren, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import { YoProjectMenu, YoToolMenu, YoUserMenu } from '@yakoffice/shared-components';
import { useNavigationRail } from './use-navigation-rail';
import styles from './navigation-rail.module.sass';
import { Stack } from 'react-bootstrap';
import { PublisherNavigationRailItems } from '@yakoffice/navigation-rail';
import { IamNavigationRailItems } from './iam-navigation-rail-items';
import { useCookies } from 'react-cookie';
import { NavigationRailPropsType } from '@yakoffice/navigation-rail';

export const NavigationRailContent: FC<PropsWithChildren<NavigationRailPropsType>> = (props) => {

    const {
        authUser,
        yoConfig,
        yoProjects,
        yoTools,
        error,
        isDevSite
    } = useNavigationRail();

    const [cookies, setCookie] = useCookies(['navigationRailCollapsedStatus']);
    const [collapsed, setCollapsed] = useState(cookies.navigationRailCollapsedStatus);

    function toggleSidebar() {
        setCollapsed(!collapsed);
        setCookie('navigationRailCollapsedStatus', !cookies.navigationRailCollapsedStatus, {
            path: '/',
            domain: '.yakoffice.app',
            sameSite: 'none',
            secure: true
        });
    }

    return (
        <div id="navigationRail" className={`${styles.navigationRail} ${collapsed && styles.collapsed} themed-project`}>

            <div className={`${styles.navigationRailNav} nav flex-column`}>

                <Stack gap={3} style={{ maxWidth: '100%', height: '100%' }}>

                    <Button variant="secondary" className={styles.toggleBtn} onClick={toggleSidebar}>
                        <i className="fas fa-bars" />
                    </Button>

                    {authUser &&
                        <YoProjectMenu authUser={authUser} yoProjects={yoProjects} toolId={props.toolId}
                                       isDevSite={isDevSite()} />
                    }

                    <div className={styles.navigationRailToolsWrapper}>

                        {authUser &&
                            <YoToolMenu authUser={authUser} toolId={props.toolId} isDevSite={isDevSite()}
                                        projects={yoProjects} />}

                        {authUser && yoConfig &&
                            <IamNavigationRailItems authUser={authUser}
                                                    hostedInPortal={props.hostedInPortal ?? false}
                                                    portalUrl={yoConfig.portalUrl} />}

                        {authUser &&
                            <PublisherNavigationRailItems authUser={authUser}
                                                          publisherLinkOverrides={props.publisherLinkOverrides}
                                                          isDevSite={isDevSite()}
                                                          toolId={props.toolId}
                            />}

                        {props.navigationRailItems && props.navigationRailItems.map((navigationItem, index) => (
                            <NavLink to={navigationItem.link} className={styles.navigationRailNavItem} key={index}>
                                {navigationItem.icon}
                                <span>{navigationItem.text}</span>
                            </NavLink>
                        ))}
                    </div>

                    {
                        authUser && yoConfig &&
                        <div className={styles.userMenuWrapper}>
                            <YoUserMenu authUser={authUser}
                                        portalUsersRoute={yoConfig.portalUsersRoute}
                                        portalUrl={yoConfig.portalUrl}
                                        hostedInPortal={props.hostedInPortal ?? false} />
                        </div>
                    }


                </Stack>
            </div>
        </div>
    );
};

